import { RadioGroup } from "@headlessui/react";
import { useState } from "react";

const DeprecatedPanelThree = ({
  panelThreeSelection,
  setPanelThreeSelection,
  setModalState,
  register,
  setValue,
  setCurrentStep,
  handleSubmit,
  dataSubmit,
  currentStep,
  cardData,
  getValues,
  setIsDisabled,
}) => {
  const [selectCreditCard, setSelectCreditCard] = useState("");
  const [buttonOneChecked, setButtonOneChecked] = useState(false);
  const [buttonTwoChecked, setButtonTwoChecked] = useState(true);
  const onSubmit = () => {
    handleSubmit(dataSubmit)();
    if (getValues("selectedCard") === "newcard") setIsDisabled(false);
    else {
      if (getValues("selectedCard") !== "" && selectCreditCard !== "")
        setIsDisabled(false);
      else setIsDisabled(true);
    }
  };
  return (
    <>
      <div className="px-0 md:px-16">
        <form>
          <RadioGroup
            className="ui-form-card-row cursor-pointer font-semibold"
            name="panelThreeSelection"
            value={panelThreeSelection}
            onChange={setPanelThreeSelection}
          >
            <RadioGroup.Option
              id="ID_newCardStep1Option"
              className={({ checked }) =>
                `${
                  checked && (buttonOneChecked || !cardData?.length)
                    ? "ui-form-card selected"
                    : "ui-form-card"
                }`
              }
              tabIndex="0"
              aria-label="Select new card"
              aria-controls="ID_newCardStep1Option"
              aria-expanded="false"
              value="newcard"
              {...register("selectedCard")}
              onClick={() => {
                setButtonTwoChecked(false);
                setButtonOneChecked(true);
                setSelectCreditCard("");
                setValue("selectedCard", "newcard");
                onSubmit();
              }}
            >
              {({ checked }) => (
                <>
                  <RadioGroup.Label
                    className="block text-xxs text-ui-gray-default pr-8 cursor-pointer font-semibold"
                    as="div"
                  >
                    Enter new card number
                  </RadioGroup.Label>
                  <div className="text-xxs font-semibold pr-8 group-hover:underline">
                    <div className="ui-form-card-checkbox">
                      <svg
                        className="ui-icon w-2 h-2 text-white hidden"
                        focusable="false"
                        aria-hidden="true"
                        role="presentation"
                      >
                        <use href="#ui-icon-checkmark"></use>
                      </svg>
                    </div>
                  </div>
                </>
              )}
            </RadioGroup.Option>
            {cardData?.length > 0 && (
              <RadioGroup.Option
                id="ID_paymentStep1Option1"
                className={({ checked }) =>
                  `${
                    checked && buttonTwoChecked
                      ? "ui-form-card selected"
                      : "ui-form-card"
                  }`
                }
                tabIndex="0"
                aria-label="Select to pay this policy"
                aria-controls="ID_paymentStep2Options"
                aria-expanded="false"
                onClick={(e) => {
                  setButtonTwoChecked(true);
                  setButtonOneChecked(false);
                  setSelectCreditCard(e.target.value);
                  setValue("selectedCard", e.target.value);
                  onSubmit();
                }}
              >
                {({ checked }) => (
                  <>
                    <RadioGroup.Label as="div">
                      <div
                        id="ID_paymentStep1Option2"
                        className="group xl:basis-1/2"
                        tabIndex="0"
                        aria-label="Enable ability to choose another policy"
                        aria-controls="ID_selectPolicy"
                      >
                        <div className="ui-form-card-checkbox">
                          <svg
                            className="ui-icon w-2 h-2 text-white hidden"
                            focusable="false"
                            aria-hidden="true"
                            role="presentation"
                          >
                            <use href="#ui-icon-checkmark"></use>
                          </svg>
                        </div>

                        <div className="text-xxs font-semibold pr-8 group-hover:underline mb-1">
                          Existing cards
                        </div>

                        <select
                          id="ID_selectCard"
                          name="cards"
                          className="text-sm"
                          {...register("selectedCard")}
                          value={selectCreditCard}
                          aria-label="Select exsting card"
                          aria-controls="ID_paymentStep2Options"
                          aria-expanded="false"
                          onChange={(e) => {
                            setButtonTwoChecked(true);
                            setButtonOneChecked(false);
                            setSelectCreditCard(e.target.value);
                            setValue("selectedCard", e.target.value);
                            onSubmit();
                          }}
                        >
                          <option value="">Please select existing card</option>
                          {cardData.map((item, idx) => (
                            <option value={item.lastFour} key={idx}>
                              {`****-****-****-${item.lastFour}`}
                            </option>
                          ))}
                        </select>
                      </div>
                    </RadioGroup.Label>
                  </>
                )}
              </RadioGroup.Option>
            )}
          </RadioGroup>
        </form>
      </div>
    </>
  );
};

export default DeprecatedPanelThree;
